import { render } from "./Badage.vue?vue&type=template&id=3a22951a"
import script from "./Badage.vue?vue&type=script&lang=js"
export * from "./Badage.vue?vue&type=script&lang=js"

import "./Badage.vue?vue&type=style&index=0&id=3a22951a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__